/*
 * Copyright Huesik (c) 2019.
 * 추후 로그인 및 기타 NETWORK 통신 간에 interceptor 가 필요한 경우 이용하시면 됩니다.
 * 지금은 개발/운영간의 서버 정보 변경 용도로만 사용하고 있습니다.
 */

import axios from 'axios'
import config from '../../config'

let axiosInstance

if (process.env.NODE_ENV === 'development') {
  axiosInstance = axios.create({
    baseURL: config.SERVER.DEVELOPMENT,
  })
} else {
  // Production
  axiosInstance = axios.create({
    baseURL: config.SERVER.PRODUCTION,
  })
}

axiosInstance.interceptors.request.use(
  config => {
    console.log('REQUEST BY INSTANCE')
    return config
  },
  error => Promise.reject(error)
)


export default axiosInstance
